import React from 'react';
import { ProspectAmountValue } from '@/components/ProspectAmountValue';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { ChangeAssigneeField } from '@/components/cards/DealCardValues/ChangeAssigneeField';
import { ReferralStatus } from '@/components/cards/DealCardValues/ReferralStatus';
import { FormControl, FormLabel, Grid } from '@mui/material';
import { ProspectStageSelect } from '@/components/selects/prospectStatusSelect';
import ReferralPartnerField from '@/components/fields/ReferralPartnerField';
import { useReferralStatusFields } from '@/hooks/useReferralStatusFields';

const ClientDrawerContent = () => {
	const { clientRow } = useObjectContext();

	const isProspect = clientRow?.isProspect;

	const { getFeatureFlags } = useFeatureFlagContext();
	const salesTeamChange = Boolean(getFeatureFlags('salesTeamChange')?.active);
	const referralFields = useReferralStatusFields();

	return (
		<>
			<Grid size={{ xs: 12, sm: isProspect ? 6 : 12 }}>
				<ChangeAssigneeField
					minimal={true}
					companySalesTeamChange={true}
					disabled={!salesTeamChange}
				/>
			</Grid>
			{isProspect && (
				<>
					<Grid
						size={{ xs: 12, sm: 6 }}
						sx={{ display: 'flex', alignItems: 'flex-start' }}
					>
						<FormControl fullWidth>
							<FormLabel>Prospect stage</FormLabel>
							<ProspectStageSelect minimal={true} />
						</FormControl>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 6 }}
						sx={{ display: 'flex', alignItems: 'flex-start' }}
					>
						<FormControl fullWidth>
							<FormLabel>Referral partner</FormLabel>
							<ReferralPartnerField minimal={true} />
						</FormControl>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 6 }}
						sx={{ display: 'flex', alignItems: 'flex-start' }}
					>
						<FormControl fullWidth>
							<FormLabel>Prospect amount</FormLabel>
							<ProspectAmountValue hideLabel />
						</FormControl>
					</Grid>
				</>
			)}
			{referralFields.map((field) => (
				<Grid
					key={field.name}
					size={{ xs: 12, sm: 6 }}
					sx={{ display: 'flex', alignItems: 'flex-start' }}
				>
					<ReferralStatus field={field} />
				</Grid>
			))}
		</>
	);
};
ClientDrawerContent.displayName = 'ClientDrawerContent';
export default ClientDrawerContent;
